// #region Imports
import { useState } from "react";
import { motion } from "framer-motion";
import skills from "../../content/data/skills.json";
// #endregion


const skillMap = Object.fromEntries(
	skills
		.flatMap(category => category.items)
		.map(skill => [skill.name, skill])
);


const circleVariants = {
	DEFAULT: {
		width: "3vw",
		height: "3vw",
		borderRadius: "10rem",
	},
	HOVER: {
		width: "35%",
		height: "80%",
		borderRadius: "5rem",
	},
};


function PopUpTile({
	index,
	title,
	highlight,
	skills: projectSkills,
	bg,
	item,
	onOpen,
}) {

	const [isHover, setIsHover] = useState(false);
	const isMobile = window.matchMedia("(max-width: 500px)").matches;

	const resolvedSkills = projectSkills
		?.map(skill => skillMap[skill])
		.filter(Boolean);


	return (
		<div
			className="
				relative flex items-center justify-center
				gap-10 w-full h-fit py-5 cursor-pointer
				bg-contain font-mada small:py-0
			"
			onMouseEnter={() => setIsHover(true)}
			onMouseLeave={() => setIsHover(false)}
			onClick={onOpen}
		>

			{/* DESKTOP HOVER */}

			{!isMobile && (
				<motion.div
					className={`
						absolute left-0 w-full h-full
						mr-2 z-0 ${bg}
					`}
					animate={
						isHover
							? circleVariants.HOVER
							: circleVariants.DEFAULT
					}
					transition={{
						duration: 0.5,
						ease: "easeInOut",
						type: "spring",
					}}
				/>
			)}


			{/* CONTENT */}

			<section
				className="
					relative z-10 flex items-center
					justify-between gap-10 w-full h-full
					px-4 pl-[5%] small:px-0
					small:flex-col small:gap-4
					small:items-end
				"
			>

				{/* TITLE */}

				<aside
					className="
						flex items-center gap-4
						small:w-full small:justify-start
					"
				>

					{isMobile && (
						<motion.div
							className={`
								rounded-full h-[2rem] w-[2rem]
								shrink-0 ${bg}
							`}
							initial={{ scale: 0 }}
							animate={{ scale: 1 }}
							transition={{
								type: "spring",
								stiffness: 400,
								damping: 12,
								mass: 0.6,
							}}
						/>
					)}

					<motion.p
						className="
							w-full text-[1.2vw] leading-tight
							font-[300] text-left text-charcoal
							small:w-auto small:text-2xl
						"
						animate={{
							color: isHover
								? "#F4F9FF"
								: "#1F1F1F",
						}}
					>
						{title}
					</motion.p>

				</aside>


				{/* HIGHLIGHT + SKILLS */}

				<aside
					className="
						flex w-[65%] items-center
						small:w-[85%] small:space-y-4
						small:flex-col small:items-start
					"
				>

					{highlight && (
						<p
							className="
								flex-1 text-[0.8rem]
								text-grey
							"
						>
							{highlight}
						</p>
					)}


					{resolvedSkills?.length > 0 && (
						<ul
							className="
								flex flex-wrap items-center
								justify-end gap-2 w-[30%]
								shrink-0 small:w-full
								small:justify-start
							"
						>
							{resolvedSkills.map(skill => (
								<img
									key={skill.name}
									src={skill.logo}
									alt={skill.name}
									title={skill.name}
									className="
										w-5 h-5 object-contain
										small:h-7 small:w-7
									"
									loading="lazy"
								/>
							))}
						</ul>
					)}

				</aside>

			</section>

		</div>
	);
}


export default PopUpTile;